import { render, staticRenderFns } from "./RolePermissions.vue?vue&type=template&id=2c949cb1&scoped=true&"
import script from "./RolePermissions.vue?vue&type=script&lang=js&"
export * from "./RolePermissions.vue?vue&type=script&lang=js&"
import style0 from "./RolePermissions.vue?vue&type=style&index=0&id=2c949cb1&lang=scss&scoped=true&"
import style1 from "./RolePermissions.vue?vue&type=style&index=1&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2c949cb1",
  null
  
)

export default component.exports